module["exports"] = [
  "#####",
  "#####-###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/address/postcode.js
 ** module id = 949
 ** module chunks = 0
 **/